// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"112":"a153368f","168":"7f820904","278":"dede7529","291":"f4aacf73","453":"29d12807","534":"5442d9db","905":"b9171baa","988":"bd860b23"}[chunkId] + ".chunk.js";
};